/* Explicit cart acknowledgement; never removes or replaces the merchandise. */
(function () {
  if (window.KKCartBackorder) return;
  var api = window.KKCartBackorder = { busy: false };
  function config() { return document.querySelector('[data-kk-cart-flow-config]').dataset; }
  function root() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }
  function request(url, options, format) {
    var controller = new AbortController();
    var timer;
    var timeout = new Promise(function (_resolve, reject) {
      timer = setTimeout(function () { reject(new Error('save')); controller.abort(); }, 8000);
    });
    var result = fetch(url, Object.assign({}, options, { signal: controller.signal }))
      .then(function (r) {
        if (!r.ok) throw new Error('save');
        return format === 'text' ? r.text() : r.json();
      });
    return Promise.race([result, timeout]).finally(function () { clearTimeout(timer); });
  }
  function read(url, options) { return request(url, options); }
  function properties(value) {
    if (Array.isArray(value)) return Object.fromEntries(value);
    return value || {};
  }
  function sameProperties(a, b) {
    a = properties(a); b = properties(b);
    var keys = Object.keys(a).sort();
    return JSON.stringify(keys) === JSON.stringify(Object.keys(b).sort()) &&
      keys.every(function (key) { return a[key] === b[key]; });
  }
  function plan(item) { return String(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || 0); }
  function targets() {
    var list = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var host = document.getElementById(id);
      if (host) list.push({ id: id, section: host.dataset.id || id, selector: '.js-contents' });
    });
    if (document.getElementById('CartDrawer')) list.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' });
    if (document.getElementById('cart-icon-bubble')) list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return list;
  }
  function paint(sections, list) {
    var prepared = list.map(function (t) {
      var host = document.getElementById(t.id);
      var doc = new DOMParser().parseFromString(sections[t.section] || '', 'text/html');
      var source = doc.querySelector(t.selector);
      if (!host || !source) throw new Error('refresh');
      return { target: t.id === 'CartDrawer' ? host : host.querySelector(t.selector) || host, source: source };
    });
    prepared.forEach(function (p) { p.target.innerHTML = p.source.innerHTML; });
    var drawer = document.querySelector('cart-drawer');
    var overlay = drawer && drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
    // Express controls sit outside the footer's replaceable contents.
    var hasBackorder = !!document.querySelector('[data-kk-cart-backorder]');
    document.querySelectorAll('[data-kk-cart-express]').forEach(function (el) { el.hidden = hasBackorder; });
    document.dispatchEvent(new CustomEvent('kkumi:cart-reviewed'));
  }
  function refresh(state, list) {
    try { paint(state.sections || {}, list); return Promise.resolve(); }
    catch (_) {
      var ids = list.map(function (t) { return t.section; });
      return read(root() + 'cart?sections=' + encodeURIComponent(ids.join(',')), { cache: 'no-store', credentials: 'same-origin' })
        .then(function (sections) { paint(sections, list); });
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-kk-backorder-ack]');
    if (!button) return;
    event.preventDefault();
    if (api.busy) return;
    var issue = button.closest('[data-kk-backorder-incomplete]');
    var status = issue.querySelector('[data-kk-backorder-ack-status]');
    var copy = config();
    var surface = button.closest('cart-drawer') ? 'drawer' : 'page';
    var reviewed;
    try { reviewed = JSON.parse(button.dataset.properties); } catch (_) { return; }
    api.busy = true;
    document.documentElement.setAttribute('data-kk-cart-updating', '');
    status.hidden = true;
    if (window.KKBtn) window.KKBtn.busy(button, copy.ackBusy);
    else { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    var saved = false;
    read(root() + 'cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (cart) {
      if (!Array.isArray(cart.items)) throw new Error('save');
      var acknowledged = Object.assign(Object.create(null), properties(reviewed));
      acknowledged._backorder = '1';
      acknowledged[copy.propertyName] = button.dataset.disclosure;
      var matches = cart.items.filter(function (it) {
        return String(it.variant_id) === button.dataset.variantId && plan(it) === button.dataset.sellingPlan && (sameProperties(it.properties, reviewed) || sameProperties(it.properties, acknowledged));
      });
      var line = matches.find(function (it) { return it.key === button.dataset.lineKey; });
      if (!line && matches.length === 1) line = matches[0];
      if (!line || line.quantity < 1) throw new Error('changed');
      if (sameProperties(line.properties, acknowledged)) {
        saved = true;
        return refresh({}, targets());
      }
      // Obtain fresh server stock and disclosure proof before persisting consent.
      return request(root() + 'cart?section_id=kkumi-sb-cart-status', { cache: 'no-store', credentials: 'same-origin' }, 'text')
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if (!doc.querySelector('[data-kk-sb-cart-status][data-version="1"]')) throw new Error('save');
          var current = Array.prototype.find.call(doc.querySelectorAll('[data-kk-backorder-ack]'), function (el) { return el.dataset.lineKey === line.key; });
          if (!current || current.dataset.disclosure !== button.dataset.disclosure) throw new Error('changed');
          var props = Object.assign(Object.create(null), properties(line.properties));
          props._backorder = '1';
          props[copy.propertyName] = current.dataset.disclosure;
          var list = targets();
          return read(root() + 'cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props,
              sections: list.map(function (t) { return t.section; }), sections_url: window.location.pathname })
          }).then(function (state) {
            if (!Array.isArray(state.items) || state.errors || state.status) throw new Error('save');
            if (!state.items.some(function (it) { return String(it.variant_id) === String(line.variant_id) && plan(it) === plan(line) && it.quantity >= line.quantity && sameProperties(it.properties, props); })) throw new Error('save');
            saved = true;
            return refresh(state, list);
          });
        });
    }).then(function () {
      if (window.KKCheckoutDiagnostics) window.KKCheckoutDiagnostics('backorder_acknowledged', surface);
      var checkout = document.querySelector(surface === 'drawer' ? '#CartDrawer-Checkout' : '#checkout');
      var next = document.querySelector(surface === 'drawer' ? 'cart-drawer [data-kk-backorder-ack]' : '#main-cart-items [data-kk-backorder-ack]');
      if (next) next.closest('details').open = true;
      var focus = next || checkout;
      if (focus) focus.focus({ preventScroll: true });
      var region = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      if (region) { region.textContent = copy.ackSuccess; region.setAttribute('aria-hidden', 'false'); }
    }).catch(function (error) {
      if (!status.isConnected) {
        var replacement = Array.prototype.find.call(document.querySelectorAll('[data-kk-backorder-ack]'), function (el) {
          if (el.dataset.variantId !== button.dataset.variantId || el.dataset.sellingPlan !== button.dataset.sellingPlan) return false;
          try { return sameProperties(JSON.parse(el.dataset.properties), reviewed); } catch (_) { return false; }
        });
        status = replacement && replacement.closest('[data-kk-backorder-incomplete]').querySelector('[data-kk-backorder-ack-status]');
        if (!status) {
          status = document.createElement('p');
          status.setAttribute('role', 'status');
          var host = document.querySelector(surface === 'drawer' ? 'cart-drawer .cart__ctas' : '.kkumi-summary__checkout');
          (host || document.body).appendChild(status);
        }
      }
      status.hidden = false;
      status.textContent = saved ? copy.ackRefresh : error.message === 'changed' ? copy.ackChanged : copy.ackError;
      if (window.KKCheckoutDiagnostics) window.KKCheckoutDiagnostics('backorder_ack_failed', surface, saved ? 'refresh' : error.message === 'changed' ? 'changed' : 'save');
    }).finally(function () {
      api.busy = false;
      document.documentElement.removeAttribute('data-kk-cart-updating');
      if (window.KKBtn) window.KKBtn.reset(button);
      else { button.disabled = false; button.removeAttribute('aria-busy'); }
      document.dispatchEvent(new CustomEvent('kkumi:cart-reviewed'));
    });
  });
})();
